export class SugestaoPerfil {
  idPessoa: number;
  idPlano: number;
  idPerfil: number;
  pontuacao: number;
  perfil: string;
}
